import { useParams } from "react-router-dom";
import { useEffect, useState } from "react";

// hooks
import useGetFetch from "../../../hooks/useGetFetch";

// components
import ErrorDisplay from "../../../components/ErrorDisplay";
import Loading from "../../../components/Loading";
import DeliveredDate from "../../../components/DeliveredDate";
import Dates from "../../../components/Dates";

// global
import { accountDataStore } from "../../../store/Store";

import { MatchingLoads } from "../../../funcs/helperFuncs";

export default function AccountReceivedInvoiceDetails() {
  const accountReceivedInvoices = accountDataStore(
    (data) => data.accountReceivedInvoices,
  );

  const { invId, projectId } = useParams();
  const [details, setDetails] = useState(null);
  const [invoice, setInvoice] = useState(null);

  const { isPending, error, statusCode } = useGetFetch(
    `${process.env.REACT_APP_BACKEND}/lc/account-invoice/${invId}?project_id=${projectId}`,
    setDetails,
  );

  useEffect(() => {
    if (invId && accountReceivedInvoices) {
      var inv = accountReceivedInvoices.filter((x) => x.id === parseInt(invId));
      if (inv.length > 0) {
        setInvoice(inv[0]);
      }
    }
  }, [invId, accountReceivedInvoices]);

  if (error) {
    return <ErrorDisplay message={"Something Went Wrong"} code={statusCode} />;
  } else if (isPending) {
    return <Loading />;
  }
  return (
    details &&
    details.invoice_loads &&
    invoice && (
      <div className="container-fluid">
        <h4>{invoice.invoice_name}</h4>
        {details.adjustments &&
          details.adjustments.invoice_adjustment &&
          details.adjustments.adjustment_fields && (
            <div className="p-2 border text-center project-card">
              <div className="d-flex justify-content-between project-header">
                <h5>Invoice Adjustments</h5>
              </div>
              <div className="project-card-list">
                <table className="table table-sm">
                  <thead>
                    <tr>
                      <th>Item</th>
                      <th>Type</th>
                      <th>Amount</th>
                      <th>Date</th>
                      <th>Comments</th>
                    </tr>
                  </thead>
                  <tbody>
                    {details.adjustments.adjustment_fields.map((a, idx) => (
                      <tr key={idx}>
                        <td>{a.field_name}</td>
                        <td>{a.is_credit ? "Credit" : "Charge"}</td>
                        <td>
                          ${parseFloat(a.field_value).toLocaleString("en-US")}
                        </td>
                        <Dates d={a.date_of_adjustment} />
                        <td>{a.adjustment_comments}</td>
                      </tr>
                    ))}
                    <tr>
                      <td className="form-totals">Total</td>
                      <td></td>
                      <td className="form-totals">
                        $
                        {parseFloat(
                          details.adjustments.invoice_adjustment
                            .total_adjustment,
                        ).toLocaleString("en-US")}
                      </td>
                      <td></td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          )}
        <br />
        {details.uninvoiced_loads && (
          <>
            <h4>Loads Not Invoiced</h4>
            <div className="load-display-list">
              <table className="table table-sm table-hover">
                <thead>
                  <tr>
                    <th>Load</th>
                    <th>Job</th>
                    <th>Delivered</th>
                    <th>Driver</th>
                    {!invoice.is_asset && <th>Ticket</th>}
                    <th>Weight</th>
                    {!invoice.is_asset && <th>Product</th>}
                    <th>Freight</th>
                    <th>FSC</th>
                    <th>Total</th>
                    {!invoice.is_asset && <th>Ticket is Missing</th>}
                    <th>Locked Reason</th>
                    {!invoice.is_asset && <th>Duplicate Tickets</th>}
                  </tr>
                </thead>
                <tbody>
                  {details.uninvoiced_loads.map((l, idx) => (
                    <tr key={idx}>
                      <td>{l.load_no}</td>
                      <td>{l.job_name}</td>
                      <DeliveredDate d={l.delivered_date} />
                      <td>{l.driver_name}</td>
                      {!invoice.is_asset && <td>{l.ticket_number}</td>}
                      <td>{l.weight_tons.toFixed(2)}</td>
                      {!invoice.is_asset && <td>{l.product_name}</td>}
                      <td>${l.freight_cost.toFixed(2)}</td>
                      <td>${l.fsc_cost.toFixed(2)}</td>
                      <td>${(l.freight_cost + l.fsc_cost).toFixed(2)}</td>
                      {!invoice.is_asset && (
                        <td>{l.ticket_is_missing ? "Yes" : "No"}</td>
                      )}
                      <td>{l.locked_reason}</td>
                      {!invoice.is_asset && (
                        <MatchingLoads loadNumbers={l.duplicate_tickets} />
                      )}
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </>
        )}
        <br />
        <h4>Invoiced Loads</h4>
        <div className="load-display-list">
          <table className="table table-sm table-hover">
            <thead>
              <tr>
                <th>Load</th>
                <th>Job</th>
                <th>Delivered</th>
                <th>Driver</th>
                {!invoice.is_asset && <th>Ticket</th>}
                <th>Weight</th>
                {!invoice.is_asset && <th>Product</th>}
                <th>Freight</th>
                <th>FSC</th>
                <th>Total</th>
              </tr>
            </thead>
            <tbody>
              {details.invoice_loads.map((l, idx) => (
                <tr key={idx}>
                  <td>{l.load_no}</td>
                  <td>{l.job_name}</td>
                  <DeliveredDate d={l.delivered_date} />
                  <td>{l.driver_name}</td>
                  {!invoice.is_asset && <td>{l.ticket_number}</td>}
                  <td>{l.weight_tons.toFixed(2)}</td>
                  {!invoice.is_asset && <td>{l.product_name}</td>}
                  <td>${l.freight_cost.toFixed(2)}</td>
                  <td>${l.fsc_cost.toFixed(2)}</td>
                  <td>${(l.freight_cost + l.fsc_cost).toFixed(2)}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    )
  );
}
